export function initUpdateRating() {
  const rateBlock = document.querySelector(".js-rate-block");

  if (!rateBlock) return;

  const ratingsElem = rateBlock.querySelector(".kk-star-ratings");

  const rateIsActive = !ratingsElem.classList.contains("kksr-disabled");

  const postId = JSON.parse(ratingsElem.dataset.payload)?.id;

  const rateBlockTitle =
    rateBlock.querySelector(".js-rate-block-title") ||
    rateBlock.querySelector(".title");

  function updateUserRate(userRate) {
    rateBlock.setAttribute("data-user-rate", userRate);
  }

  if (!rateIsActive) {
    const userRate = localStorage.getItem(`kk-rating-${postId}`);

    if (userRate) {
      updateUserRate(userRate);
    } else {
      rateBlockTitle.innerHTML = "You've already rated this article";
    }
    return;
  }

  const stars = ratingsElem.querySelector(".kksr-stars-inactive");

  stars.addEventListener(
    "click",
    function (event) {
      const userRate = Number(event.target.closest(".kksr-star")?.dataset.star);

      localStorage.setItem(`kk-rating-${postId}`, userRate);

      rateBlockTitle.innerHTML = "Your Rate:";

      updateUserRate(userRate);
    },
    { once: true },
  );
}
